import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchOffers } from './service';

export const fetchOffersAsync = createAsyncThunk(
  'availableOffers/fetchOffersAsync',
  async (params) => {
    try {
      const response = await fetchOffers(params);
      return response.data;
    } catch (error) {
      return {};
    }
  },
);
